import { COLLECTION_NAME } from ".";
import { useEffect } from "react";
import { updateDocument } from "db/mutations";
import { getUserId } from "services/auth";

export const useStandalone = (standalone, device, screen) => {
  const userId = getUserId();

  useEffect(() => {
    if (!userId) return;

    if (standalone) {
      updateDocument(COLLECTION_NAME, userId, {
        ["device.standalone"]: standalone,
        ["device.os"]: device,
      });
    } else if (screen.isMobile && device !== "other") {
      updateDocument(COLLECTION_NAME, userId, {
        ["device.os"]: device,
      });
    }
  }, [standalone, device, userId]);
};
